// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2gBVQ","list":"BalanceDue_list__VzbdJ","listRow":"BalanceDue_listRow__30ApS","total":"BalanceDue_total__3Ij8b"};